import { Alert, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../../../../Utils/permissions";

const InfoRow = ({ label, value }) => (
  <div className="info-row">
    <span className="info-label">{label}</span>
    <span className="info-value">{value || "-"}</span>
  </div>
);

const BoletimInformacoes = ({ boletim, setBoletim }) => {
  const navigate = useNavigate();
  const isOwner = boletim?.creatorId === localStorage.getItem("x-user-id");
  const podeEditar = hasPermission("boletins.edit.all") ||
    (isOwner && hasPermission("boletins.edit.own"));

  if (!boletim) {
    return (
      <Alert variant="danger" className="mt-3 text-center">
        Boletim não encontrado
      </Alert>
    );
  }

  return (
    <div className="boletim-panel mt-3">
      <div
        className="boletim-header"
        onClick={() => {
          setBoletim(boletim);
          navigate("/BoFromBD");
        }}
      >
        {boletim.natureza?.toUpperCase() || "NATUREZA NÃO INFORMADA"}
      </div>

      <InfoRow label="Data" value={boletim.data} />
      <InfoRow label="Número" value={boletim.numero} />
      <InfoRow label="Município" value={boletim.municipio} />

      <div className="boletim-actions">
        <Button
          size="sm"
          variant="outline-primary"
          onClick={() => {
            setBoletim(boletim);
            navigate("/BoFromBD");
          }}
        >
          Ver
        </Button>

        {podeEditar && (
          <Button
            size="sm"
            variant="outline-danger"
            onClick={() => {
              setBoletim(boletim);
              navigate("/boletim/header");
            }}
          >
            Editar
          </Button>
        )}
      </div>
    </div>
  );
};

export default BoletimInformacoes;
